/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 24/11/2013
 * Time: 15:53
 * To change this template use File | Settings | File Templates.
 */



angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayHr_Resource',["$resource","$location",
        function ($resource,$location)
        {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/workingPeriodDayHrs/:id',{}, {});
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayHr',["WorkingPeriodDayHrData","WorkingPeriodDayHr_Resource","Activity","Period",
        function (WorkingPeriodDayHrData,WorkingPeriodDayHr_Resource,Activity,Period)
        {
        //WorkingPeriodDay inherit of $resource

        var  WorkingPeriodDayHr = function (resource,workingPeriodDay, isApplicationLoading)
        {
            this.id = null;
            this.workingPeriodDay = null;
            this.humanResourceId = null;
            this.specificPeriod = false;
            this.onLineBooking = true;
            this.period = null; //Period null means no work for resource
            this.activities = [];

            WorkingPeriodDayHrData.add(this);

            if (workingPeriodDay!==undefined)
                this.workingPeriodDay = workingPeriodDay;
            if (resource!==undefined && resource!=null)
            {
                this.loadObject(resource, isApplicationLoading);
            }
        }
        WorkingPeriodDayHr.prototype.loadObject = function(object, isApplicationLoading)
        {
            if (!this.id)
                this.id = object.id;
            this.humanResourceId = object.humanResourceId;
            this.specificPeriod = object.specificPeriod;
            this.onLineBooking = object.onLineBooking;
            var activity;
            if (object.activities)
                for (var i =0;i< object.activities.length;i++)
                {
                    activity = new Activity(object.activities[i], null, isApplicationLoading);
                    activity.workingPeriodDayHr = this;
                    this.activities.push(activity);

                }
            this.setPeriod(object.period);
        }
        WorkingPeriodDayHr.prototype.setPeriod = function(period)
        {
            if (period)
                this.period = new Period(period);
            else
                this.period =null;
        }
        WorkingPeriodDayHr.prototype.getObjectResource = function()
        {
            var res = new WorkingPeriodDayHr_Resource();
            res.id = this.id;
            res.humanResourceId = this.humanResourceId;
            res.specificPeriod = this.specificPeriod;
            res.onLineBooking = this.onLineBooking;
            if (this.workingPeriodDay)
                res.workingPeriodDayId=this.workingPeriodDay.id;
            res.activities=[];
            if (this.activities)
                for (var i =0;i< this.activities.length;i++)
                    res.activities.push(this.activities[i].getObjectResource());
            if (this.period)
            {
                res.period = this.period.getObjectResource();
            }

            return  res;
        }
        WorkingPeriodDayHr.prototype.setId = function(id)
        {
            this.id = id;
        }
        WorkingPeriodDayHr.prototype.getId = function()
        {
            return this.id;
        }
        WorkingPeriodDayHr.prototype.addActivity = function(activity)
        {
            if (activity)
            {
                this.activities.push(activity);
                activity.workingPeriodDayHr = this;
            }
        }
        WorkingPeriodDayHr.prototype.removeActivity = function(activity)
        {
            if (activity)
            {
                var index = this.activities.indexOf(activity);
                if (index!=-1)
                    this.activities.splice(index,1);
            }
        }
        WorkingPeriodDayHr.prototype.getActivityById = function(id)
        {
            for (var i =0;i< this.activities.length;i++)
                if (this.activities[i].id==id)
                    return this.activities[i];
            return null;
        }


        return WorkingPeriodDayHr;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayHrSrv',["$log","WorkingPeriodDayHr_Resource","UserActionData","WorkingPeriodDayHrData","ServerSrv",
        function ($log,WorkingPeriodDayHr_Resource,UserActionData,WorkingPeriodDayHrData,ServerSrv)
        {
        let workingPeriodDayHrSrv = {};

        workingPeriodDayHrSrv.save =  function(workingPeriodDayHr,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(workingPeriodDayHrSrv.saveSync, workingPeriodDayHr, successFunction, errorFunction);
        };

        workingPeriodDayHrSrv.saveSync =  function(workingPeriodDayHr,successFunction,errorFunction) {
            var workingPeriodDayHrRes = workingPeriodDayHr.getObjectResource();
            workingPeriodDayHrRes.$save({}, //no params
                function (data) {
                    try{
                        workingPeriodDayHr.setId(data.id);
                        UserActionData.add(data.userAction);
                        if (data.activitiesId && data.activitiesId.length == workingPeriodDayHr.activities.length)
                        //Assume that returned list has the same order
                            for (var i=0;i< data.activitiesId.length;i++)
                                workingPeriodDayHr.activities[i].setId(data.activitiesId[i]);
                        if (successFunction != undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try{
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };

        workingPeriodDayHrSrv.remove =  function(workingPeriodDayHr,successFunction,errorFunction) {
            ServerSrv.startSavingProcess(workingPeriodDayHrSrv.removeSync, workingPeriodDayHr, successFunction, errorFunction);
        };
        workingPeriodDayHrSrv.removeSync =  function(workingPeriodDayHr,successFunction,errorFunction)
        {
            let workingPeriodDayHrRes = new WorkingPeriodDayHr_Resource();
            workingPeriodDayHrRes.$remove({id:workingPeriodDayHr.id}, //no params
                function (data) {
                    try{
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        workingPeriodDayHrSrv.updateLocally =  function(id,objectToRestore)
        {
            var wpDayHr =  WorkingPeriodDayHrData.getById(id)
            if (wpDayHr!=null)
            {
                wpDayHr.loadObject(objectToRestore);
            }
            return wpDayHr;
        };
        workingPeriodDayHrSrv.removeLocally =  function(id,object)
        {
            var wpDayHr =  WorkingPeriodDayHrData.getById(id)
            if (wpDayHr!=null)
            {
                wpDayHr.workingPeriodDay.removeWorkingPeriodDayHr(wpDayHr)
            }
            return wpDayHr;
        };
        workingPeriodDayHrSrv.addLocally =  function(id,objectToRestore)
        {
            var wpDayHr =  WorkingPeriodDayHrData.getById(id)
            if (wpDayHr!=null)
            {
                wpDayHr.loadObject(objectToRestore);
                WorkingPeriodDayHrData.add(wpDayHr);
            }
            return wpDayHr;
        };

        return workingPeriodDayHrSrv;
    }
    ]);


angular.module('FlexyBeautyApp.services').
    factory('WorkingPeriodDayHrData',[
        function ()
        {
        var  workingPeriodDayHrData =
        {
            indexWorkingPeriodDayHrs : []
        };
        workingPeriodDayHrData.getById =  function(workingPeriodDayHrId)
        {
            for (var i=0;i<this.indexWorkingPeriodDayHrs.length;i++)
                if (this.indexWorkingPeriodDayHrs[i].id==workingPeriodDayHrId)
                    return this.indexWorkingPeriodDayHrs[i];
            return null;
        }
        workingPeriodDayHrData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexWorkingPeriodDayHrs.length)
                return this.indexWorkingPeriodDayHrs[servIndex];
            else
                return null;
        }
        workingPeriodDayHrData.getIndexOf =  function(workingPeriodDayHr)
        {
            if (workingPeriodDayHr)
                return this.indexWorkingPeriodDayHrs.indexOf(workingPeriodDayHr);
            return -1;
        }
        workingPeriodDayHrData.add =  function(workingPeriodDayHr)
        {
            this.indexWorkingPeriodDayHrs.push(workingPeriodDayHr);
            return this.indexWorkingPeriodDayHrs.length-1;
        }
        workingPeriodDayHrData.clear =  function()
        {
            workingPeriodDayHrData.indexWorkingPeriodDayHrs = [];
        }
        return workingPeriodDayHrData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/WorkingPeriodDayHr.js